import InvoicePaymentsHeader from './InvoicePaymentsHeader';

export default InvoicePaymentsHeader;
